import _ from 'underscore';
import Backbone from 'backbone';
import Cache from 'root/cache';

var Router = Backbone.Router.extend({
    routes: {
        'signup':                 'signUp',
        'signup/':                'signUp',
        'signup/confirm':         'signUp',
        'signup/r/:code':         'signUpReferral',

        'join/:code':             'joinWorkspace',
        'join/:code/':            'joinWorkspace',

        'workspace':              'workspaceSelect',
        'workspace/':             'workspaceSelect',

        'password/forgot':        'forgotPassword',
        'password/reset/:key':    'resetPassword',

        'invitation/(:key)':      'userInvitation',

        'p/*key/roadmap':         'portalRoadmap',
        'p/*key/roadmap/:id':     'portalRoadmap',
        'p/*key/announcement':    'portalAnnouncement',
        'p/*key/announcement/:id':'portalAnnouncement',
        'p/*key/idea/:id':        'portalViewFeedback',
        'p/*key/reset/:id':       'portalResetPassword',

        '':                       'index',
        ':route/*splat':          'index',
        ':route':                 'index'
    },

    initialize: function() {
    },

    navigate: function(fragment, options) {
        var success = Backbone.Router.prototype.navigate.call(this, fragment, options);

        if (typeof Userback !== 'undefined' && typeof Userback.refresh === 'function') {
            Userback.refresh();
        }

        Cache.app.trackEvent('pageview');

        return success;
    },

    // get page query string
    getQueryString: function(key) {
        var search = window.location.search.replace(/^\?/, '').split('&');
        var query_string = {};

        _.each(search, function(parameter) {
            parameter = parameter.split('=');

            if (parameter.length === 2 && query_string[parameter[0]] === undefined) {
                query_string[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
            }
        });

        if (key) {
            return query_string[key];
        } else {
            return query_string;
        }
    },

    // add parameter to current query string
    addQueryString: function(parameter, value, options) {
        var query_string = this.getQueryString();
        query_string[parameter] = value;

        var search = [];
        _.each(query_string, function(value, key) {
            search.push(key + '=' + encodeURIComponent(value));
        });

        this.navigate(window.location.pathname + '?' + search.join('&'), options);
    },

    addMultipleQueryString: function(parameters, options) {
        var query_string = this.getQueryString();

        _.each(parameters, function(value, key) {
            query_string[key] = value;
        });

        var search = [];
        _.each(query_string, function(value, key) {
            search.push(key + '=' + encodeURIComponent(value));
        });

        this.navigate(window.location.pathname + '?' + search.join('&'), options);
    },

    removeQueryString: function(parameter, options) {
        if (!Array.isArray(parameter)) {
            parameter = [parameter];
        }

        var query_string = this.getQueryString();

        parameter.forEach(function(key) {
            delete query_string[key];
        });

        var search = [];
        _.each(query_string, function(value, key) {
            search.push(key + '=' + encodeURIComponent(value));
        });

        if (search.length) {
            this.navigate(window.location.pathname + '?' + search.join('&'), options);
        } else {
            this.navigate(window.location.pathname, options);
        }
    },

    checkAccess: function() {
        if (!Cache.account) {
            var pathname_to_ignore = ['/login', '/login/'];

            if (pathname_to_ignore.indexOf(window.location.pathname) === -1) {
                var redirect_url = '/login/?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);

                if (window.location.origin === Cache.app.host) {
                    // SPA navigation, no page reload
                    this.navigate(redirect_url, {trigger: true});
                } else {
                    // full page reload
                    window.location.href = Cache.app.host + redirect_url;
                }
            }

            return false;
        }

        return true;
    }
});

export default new Router();
